export class SelectedOffer {
  private _id: string;
  private _selected: boolean;

  get id() {
    return this._id;
  }
  set id(id: string) {
    this._id = id;
  }
  get selected() {
    return this._selected;
  }
  set selected(selected: boolean) {
    this._selected = selected;
  }

  constructor(id: string, selected: boolean) {
    this._id = id;
    this._selected = selected;
  }

  select(): void {
    this._selected = !this._selected;
  }
}



// WEBPACK FOOTER //
// ./src/app/interfaces/selected-offer.model.ts